import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { getSmartPropertyRunStatusContent } from './getSmartPropertyRunStatusContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SmartPropertyRunStatus = ({
  error,
  status
}) => {
  const {
    body,
    header,
    icon
  } = getSmartPropertyRunStatusContent({
    error,
    status
  });
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "100",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "100",
      children: [icon, /*#__PURE__*/_jsx(Text, {
        typography: "heading-25",
        children: header
      })]
    }), /*#__PURE__*/_jsx(Text, {
      typography: "detail-200",
      children: body
    })]
  });
};